import type { PayloadAction, Draft, WritableDraft } from "infrastructure/store";
import { updateTableSliceEntity } from "infrastructure/store/helpers";
import { ApiState } from "infrastructure/api";
import { MenuItem } from "consts/waMessaging";
import type { ResourceResponse, ThunkReturnType } from "types";
import type {
    WaMessagingState,
    WaMessagesResponse,
    WaMessagesSetupsResponse,
    WaMessageSetup,
    PhoneVerificationsResponse,
    FailedPhoneVerificationsResponse,
    WaTemplatesSetupsResponse,
    WaTemplateSetup
} from "./types";

export const waMessagingResourceRequestLoading = (menuItem: MenuItem) =>
    (state: WritableDraft<WaMessagingState>) => {
        state[menuItem].tableLoadingState = ApiState.Pending;
    };

export const waMessagingResourceRequestRejected = (menuItem: MenuItem) =>
    (state: WritableDraft<WaMessagingState>) => {
        state[menuItem].tableLoadingState = ApiState.Failed;
    };

export const exportWaMessagingResourceLoading = (menuItem: MenuItem) => (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<Draft<ApiState>>
) => {
    state[menuItem].exportLoadingState = payload;
};

export const waMessagesRequestFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<WaMessagesResponse>>
) => {
    state[MenuItem.WaMessages].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.WaMessages].tableSlice = payload!.data;
};

export const waMessagesSetupsRequestFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<WaMessagesSetupsResponse>>
) => {
    state[MenuItem.WaMessagesSetups].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.WaMessagesSetups].tableSlice = payload!.data;
};

export const createWaMessagesSetupFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<WaMessageSetup>>>
) => {
    state[MenuItem.WaMessagesSetups].tableLoadingState = ApiState.Succeeded;

    if (!state[MenuItem.WaMessagesSetups].tableSlice || !payload) {
        return;
    }

    state[MenuItem.WaMessagesSetups].tableSlice!.data.unshift(payload.data);
    state[MenuItem.WaMessagesSetups].tableSlice!.to += 1;
    state[MenuItem.WaMessagesSetups].tableSlice!.total += 1;
};

export const updateWaMessagesSetupFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<WaMessageSetup>>>
) => {
    state[MenuItem.WaMessagesSetups].tableLoadingState = ApiState.Succeeded;

    if (!state[MenuItem.WaMessagesSetups].tableSlice || !payload) {
        return;
    }

    state[MenuItem.WaMessagesSetups].tableSlice!.data = updateTableSliceEntity(
        state[MenuItem.WaMessagesSetups],
        payload.data
    );
};

export const phoneVerificationsRequestFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<PhoneVerificationsResponse>>
) => {
    state[MenuItem.PhoneVerifications].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.PhoneVerifications].tableSlice = payload!.data;
};

export const failedPhoneVerificationsRequestFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<FailedPhoneVerificationsResponse>>
) => {
    state[MenuItem.FailedPhoneVerifications].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.FailedPhoneVerifications].tableSlice = payload!.data;
};

export const waTemplatesSetupsRequestFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<WaTemplatesSetupsResponse>>
) => {
    state[MenuItem.WaTemplatesSetups].tableLoadingState = ApiState.Succeeded;
    state[MenuItem.WaTemplatesSetups].tableSlice = payload!.data;
};

export const createWaTemplatesSetupFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<WaTemplateSetup>>>
) => {
    state[MenuItem.WaTemplatesSetups].tableLoadingState = ApiState.Succeeded;

    if (!state[MenuItem.WaTemplatesSetups].tableSlice || !payload) {
        return;
    }

    state[MenuItem.WaTemplatesSetups].tableSlice!.data.unshift(payload.data);
    state[MenuItem.WaTemplatesSetups].tableSlice!.to += 1;
    state[MenuItem.WaTemplatesSetups].tableSlice!.total += 1;
};

export const updateWaTemplatesSetupFulfilled = (
    state: WritableDraft<WaMessagingState>,
    { payload }: PayloadAction<ThunkReturnType<ResourceResponse<WaTemplateSetup>>>
) => {
    state[MenuItem.WaTemplatesSetups].tableLoadingState = ApiState.Succeeded;

    if (!state[MenuItem.WaTemplatesSetups].tableSlice || !payload) {
        return;
    }

    state[MenuItem.WaTemplatesSetups].tableSlice!.data = updateTableSliceEntity(
        state[MenuItem.WaTemplatesSetups],
        payload.data
    );
};
